import React from "react";
import './Components.css'
import { Trans } from "react-i18next";

export const StatusBox = ({ status, children }) => (
  <div
    className = {`px-2 py-1 rounded d-inline-block status ${status.toLowerCase()}`}>
        <Trans>{children ? children : status}</Trans>
  </div>
);

export default StatusBox;
